/* eslint-disable max-len */
import React from 'react'

const pageContent = () => [
	{
		title: '',
		text: (
			<>
				<p>
					By participating in the “Renfield: Bring Your Own Blood” Dares (the “Dare(s)”), you grant permission to Skybound Game Studios, Inc.
					and/or its parent company, subsidiaries, affiliates, successors and assigns (“Skybound”) to use your likeness, entry, name and user/screen
					name for purposes of advertising and trade without further compensation to you. As such, where permitted by applicable law, Skybound
					shall have the right to print, publish, broadcast, distribute, and use in any media known now or hereafter developed, in perpetuity, worldwide,
					and without limitation, your entry, name, user/screen name, profile picture, voice, likeness, and/or statements about the Dares for news, publicity,
					advertising, promotional purposes, trade, information, and public relations without any further notice, review, consent, compensation, or remuneration
					to you. The Dare(s) are not sponsored, endorsed, administered by or associated with Universal Pictures, a division of Universal City Studios LLC and its parents,
					subsidiaries and affiliates (collectively, the “Universal Parties”).
				</p>
				<p>
					You understand and agree your participation in the Dares is an original work and does not violate any living or deceased person's or entity's proprietary or
					intellectual property rights not included in the rights allowed for completing the Dares. You shall defend or settle against such claims at
					your sole expense and you shall indemnify, defend and hold harmless Skybound and the Universal Parties from any suit or claim arising from such improper usage. Further,
					you agree that (i) your completed Dare entry must remain on your Twitch page for at least sixty (60) days, provided that you must take down any Dare
					entry from your Twitch page upon Skybound’s written request within twenty-four (24) hours.
				</p>

				<p>
					In its sole discretion, Skybound reserves the right to modify, suspend, cancel, or terminate the Dares at any time. Further,
					in its sole discretion, Skybound shall have the right to maintain the integrity of the Dares, to void entries for any reason, including,
					but not limited to any disallowed entry methods (e.g. multiple entries from the same user unless specified on the respective Dares’ page,
					multiple entries from the same computer beyond the number allowed by the Dares, etc.), or the use of bots, macros, scripts, or other technical
					means for entering. Attempts by any entrant to deliberately damage any website or undermine the legitimate operation of the Dares may be a
					violation of criminal and civil laws. If any such attempt is made, Skybound reserves the right to seek damages to the fullest extent permitted
					by applicable law.
				</p>

				<p>
					Your entry into any Dare constitutes your agreement to release and hold harmless Skybound, the Universal Parties, and their subsidiaries, representatives, affiliates,
					partners, advertising and promotion agencies, successors, agents, assigns, directors, employees, sponsors and officers against and from any and all claims,
					liability, illness, injury, death, litigation, loss, or damages that may occur, directly or indirectly from (a) your participation in the Dares;
					(b) your acceptance, possession, use or misuse of any reward and/or compensation (as applicable); (c) any type of technical failure; (d) the unavailability
					or inaccessibility of any transmission, phone, or Internet service; (e) unauthorized intervention in any part of the entry process for the Dares, (f)
					electronic error or human error in any Dares administration or the processing of entries.
				</p>

				<p>
					THE DARES ARE GOVERNED BY THE LAWS OF THE UNITED STATES OF AMERICA AND STATE OF CALIFORNIA,
					WITHOUT RESPECT TO CONFLICT OF LAW DOCTRINES. You agree, as a condition of participating in the Dares,
					that if any disputes cannot be resolved between you and Skybound and/or the Universal Parties, and if causes of action arise out of,
					or are connected with, the Dares, they shall be individually resolved exclusively before a court located in
					California and having jurisdiction, without resorting to any form of class action. Under no circumstances in any
					such dispute shall you be permitted to obtain awards for, and hereby waives all rights to, punitive, incidental, exemplary, or consequential damages,
					including reasonable attorney's fees, other than participant’s actual out-of-pocket expenses (i.e. costs associated with entering any Dare), loss of use, data,
					business or profits, arising out of or in connection with participation of the Dares, whether such liability arises from any claim based upon contract, warranty,
					tort (including negligence), strict liability or otherwise, and whether or not such party has been advised of the possibility of such damage. You waive all
					rights to have damages multiplied or increased.
				</p>
				<p>
					Skybound and the Universal Parties are in no way sponsored by, endorsed by, administered by, or associated with Twitch, TikTok, or YouTube and the Dares
					should not be construed as having such a relationship. Skybound and the Universal Parties make no representations or warranties of any kind regarding any
					partnerships with Twitch, TikTok, or YouTube related to the Dares.
				</p>
				<p>
					By participating in the Dares, you agree to the terms herein. In the event of conflict or discrepancy between these Rules for Creators and the
					Terms of Service located at (<a href="https://daredrop.com/terms">https://daredrop.com/terms</a> ), these Rules for Creators shall control.
				</p>
			</>
		),
	},
]

export default pageContent
